import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@mui/material';
import { Iconify } from 'src/components';

const MarkAsSpamMenuItem = ({ params, handleMarkAsSpam }) => {
    if (params.row?.is_archived || params.row?.is_archive_pending) {
        return null;
    }
    return (
        <MenuItem onClick={() => handleMarkAsSpam(params.row)} sx={{ color: 'error.main' }}>
            <Iconify icon={'ic:baseline-report'} />
            Mark as Spam
        </MenuItem>
    );
};

export default MarkAsSpamMenuItem;

MarkAsSpamMenuItem.propTypes = {
    params: PropTypes.object,
    handleMarkAsSpam: PropTypes.func,
};
